import React, { Component } from 'react';
import CSSModules from 'react-css-modules'
// import Helmet from 'react-helmet'
import {
  // Link,
  // LinkIcon,
  BenchmarkGrid,
  GetStartedInput
} from '../../components'
import Styles from './IndexFunds.css'

@CSSModules(Styles)
export default class IndexFunds extends Component {
  constructor(props) {
    super(props)
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  render() {
    return (
      <div styleName='page'>
        <BenchmarkGrid />
        <GetStartedInput />
      </div>
    )
  }
}
